export const getBookingMasterDataEndpoint = (tenantId: string) =>
  `/berths/bookings/master_data?tenant_id=${tenantId}` as const
